import { TokenResultModel } from 'api-hooks/auth/model';
import { jwtDecode } from 'jwt-decode';
import { useCookie } from 'next-cookie';

export class CredentialCookieStorage {
  static cookie = useCookie();

  static get(name?: string) {
    if (typeof window === 'undefined') return;
    if (name) {
      return CredentialCookieStorage.cookie.get(name);
    }

    const accessToken = CredentialCookieStorage.cookie.get('access-token');
    const refreshToken = CredentialCookieStorage.cookie.get('refresh-token');
    if (accessToken && refreshToken) {
      return {
        accessToken,
        refreshToken,
      };
    }

    return null;
  }

  static set(result: TokenResultModel) {
    CredentialCookieStorage.cookie.set('access-token', result.accessToken);
    CredentialCookieStorage.cookie.set('refresh-token', result.refreshToken);
  }

  static remove() {
    if (typeof window === 'undefined') return;
    CredentialCookieStorage.cookie.remove('access-token');
    CredentialCookieStorage.cookie.remove('refresh-token');
  }

  static isExpired(minutes = 1) {
    if (typeof window === 'undefined') return;

    const accessToken = CredentialCookieStorage.cookie.get(
      'access-token',
    ) as string;
    if (!accessToken) return;

    const exp = jwtDecode(accessToken).exp;
    if (!exp) return;

    const now = new Date();
    const tolerence = minutes * 60 * 1000;
    return exp * 1000 < now.getTime() - tolerence;
  }
}
